import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ApiService } from "@app/services/api.service";
import { AuthService } from "@app/services/auth.service";
import { DrawerService } from "@app/services/drawer.service";
import { QuoteService } from "@app/services/quote.service";
import { BaseController, IBaseScope } from "@app/views/base.view";
import { IProduct, IRootScope } from "@models";
import { icons } from "@tools";
import { StateService } from "@uirouter/angularjs";

export interface IProductCompareScope extends IBaseScope {
    model: IProduct[];
    removeProduct: (id: number) => void;
    addToQuote: (product: IProduct) => void;
}

@NgView({
    token: Token.ProductCompareView,
    dependencies: [
        Token.$Scope,
        Token.$State,
        Token.$RootScope,
        Token.ApiService,
        Token.DrawerService,
        Token.QuoteService,
        Token.Model
    ],
    resolves: [
        {
            name: "model",
            dependencies: [
                Token.ApiService,
                Token.AuthService,
                Token.$StateParams,
                Token.$RootScope,
            ],
            fn: (
                api: ApiService,
                authService: AuthService,
                $stateParams: any,
                $rootScope: IRootScope
            ) => {
                return authService.authPromise.then(() =>
                    api.products.getBatch({ ids: $stateParams.ids }, $rootScope.contentTracker)
                    // api.products.search({ 
                    //     query: `id:(${$stateParams.ids.join(" OR ")})`
                    // }, $rootScope.contentTracker)
                );
            }
        }
    ]
})
export class ProductCompareController extends BaseController {

    constructor(
        $scope: IProductCompareScope,
        $state: StateService,
        $rootScope: IRootScope,
        api: ApiService,
        drawerService: DrawerService,
        quoteService: QuoteService,
        model: IProduct[]
    ) {

        super();
        drawerService.setHelpUrl("Products");
        drawerService.pageTitle = loc.productcomparison;
        drawerService.pageType = loc.product;
        drawerService.pageIcon = icons.cast;

        $scope.model = model;
        

        $scope.addToQuote = (product: IProduct) => {
            quoteService.addProduct({ idProduct: product.id, qty: product.minQty, addLocally: true });
        };

        $scope.removeProduct = (id) => {
            $rootScope.comparedProducts.removeWhere(p => p == id);
            if ($rootScope.comparedProducts.length > 0) {
                $state.go("kb.productCompare", { ids: $rootScope.comparedProducts });
            } else {
                $state.go("kb.products");
            }
        };
    }
}
